import React from 'react';
import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';

interface IProps {
  operations: Operation[],
  operationsSelected: string[]
}

const SettingsPlugin: React.FC<IProps> = React.lazy(() => importFromS3('settings'));

export const SettingsPluginContainer: React.FC<IProps> = ({ operations, operationsSelected }: IProps) => <SettingsPlugin
  operations={operations}
  operationsSelected={operationsSelected}
/>;
